module.exports = __webpack_public_path__ + "media/images/bus/conditions/DRIN-cba9a33d594763aeaf9e11a8ea8bda5f.svg";